import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
        <h1>Bienvenidos al sistema de reportes de los formularios de retroalimentación estudiantil.</h1>
        <p>
          Este sistema permite a la comunidad politécnica acceder a los resultados de las evaluaciones docentes. Este proceso es planificado y ejecutado por la 
          Secretaria Técnica de Aseguramiento de la Calidad (STAC) con el objetivo de retroalimentar a los procesos educativos y al personal académico de la ESPOL.
        </p>
        <p>
          La información que se proporciona a través de los formularios de retroalimentación estudiantil es de carácter confidencial. Por este motivo el personal académico 
          recibe información luego de finalizado el periodo académico, de forma agregada y anónima; al igual que las unidades a cargo de los servicios evaluados.
        </p>
      </div>
    );
  }
}
